




































































































































































































































































































import {
  defineComponent,
  ref,
  reactive,
  computed,
  getCurrentInstance,
  ComponentInternalInstance,
  onMounted,
  onUnmounted,
  toRefs,
  watch,
} from '@vue/composition-api';
import dayjs from 'dayjs';
import _ from 'lodash';
import Cookies from 'js-cookie';
import { DialogInstance, DialogPlugin } from 'tdesign-vue';

import RowItem from '@/renderer/views/desktop/FileManagement/Transmission/components/RowItem.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import collectFileHandler from '@/renderer/views/common/collect/compositions/collectFileHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import { simpleTransmissionFileHandler } from '@/renderer/views/common/collect/compositions/simpleTransmissionFileHandler';
import { collectInfoHandler } from '@/renderer/views/common/collect/compositions/collectInfoHandler';

// 引入工具类
import { getSpeedAndUnit } from '@/renderer/scripts/utils/tools/packages/unit';
import tips from '@/renderer/scripts/utils/tips';
import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import collectAccessTokenManager from '@/renderer/scripts/utils/AccessTokenManager/collect';
import smh, { SMH } from '@/renderer/scripts/smh';
import { Task, TaskEvents } from '@/renderer/scripts/utils/TaskManager/types';
import { downloadByLink } from '@/renderer/scripts/utils/tools';
import { downloadUrlFileToLocal, getDownloadPath } from '@/renderer/scripts/utils/download/downloadHelper';
import { IS_BROWSER } from '@/common/constant';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

interface RequireObj {
  max?: number;
  required?: boolean;
  whitespace?: boolean;
  validator?: any;
  message: string;
}

interface ValidateItem {
  validateResult: any;
  firstError: string;
}

export default defineComponent({
  components: {
    RowItem,
  },
  props: {
    collectToken: {
      type: String,
      require: true,
      default: '',
    },
    width: {
      type: Number,
      default: 450,
    },
    mode: {
      type: String,
      default: 'page',
    },
    // 默认是提交页面
    isSubmit: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;

    // 限制上传的总数
    const limitNum = 30;

    // 全局页面的loading，在校验的时候也有用到
    const loading = ref(false);

    // 收集状态：参与收集（待收集、收集中）
    enum CollectEnum {
      COLLECT = 0,
      COLLECTING = 1,
      COLLECTERROR = 2,
    }

    // 默认样例文件数量
    const defaultExampleNum = ref(2);

    // 入参必备的判断
    const { collectToken } = toRefs(props);

    // 收集任务信息相关
    const {
      collectTask,
      orgLogoInfo,
      isExpire,
      isInvalid,
      collectdUsers,
      collectHistoryList,
      methods: collectInfoMethods,
    } = collectInfoHandler(collectToken.value);

    // 简单的文件传输协议(上传）
    const {
      taskManager,
      methods: fileMethods,
      upListTotal,
      uploadList,
      handleTransmissionOperate,
    } = simpleTransmissionFileHandler({ type: 'upload' });

    // 当前能上传的文件数
    const limit = computed(() => {
      return limitNum - collectHistoryList.value.length;
    });

    const { acceptMediaTypes, collectingFileList, methods: collectFileMethods } = collectFileHandler(collectTask);

    // 用户之前提交的规则
    const beforeRuleData = reactive<{ [key: string]: string }>({});

    // todo 这里下载的spaceId需要和示例文件对应上
    const { methods: downloadMethods } = downloadHandler(collectTask.spaceId as any);

    // 剩余示例文件数目
    const remainExampleFileNum = computed(() => {
      return collectTask.exampleFiles.length - defaultExampleNum.value;
    });

    const rulePrefix = ref('rule');
    const ruleData = reactive<{ [key: string]: string }>({});
    const requiredRules = computed(() => {
      const result: {
        [key: string]: RequireObj[];
      } = {};
      // 初始化校验规则
      const len = collectTask.namingRules.length;
      for (let i = 0; i < len; i++) {
        const item = collectTask.namingRules[i];
        const isPhone = item === i18n_t('Special.手机号');
        result[item] = [
          {
            required: true,
            message: i18n_t('命名规则不能为空'),
          },
          {
            max: 30,
            message: i18n_t('最多输入30个字'),
          },
          {
            whitespace: true,
            message: i18n_t('命名规则不能为空'),
          },
          {
            validator: (val: string | string[]) => {
              if (isPhone) {
                const reg = /^\+?\d*$/;
                return reg.test(val as string);
              }
              if (val) {
                return val.indexOf('/') === -1;
              }
              return true;
            },
            message: `${isPhone ? i18n_t('请输入正确的手机号码') : i18n_t('不允许输入/')}`,
          },
        ];
      }
      return result;
    });
    const collectPanel = ref('history');
    const taskDetail = reactive({
      task: {},
      show: false,
    });
    // 交换accessToken的状态
    const exchange = ref('pending');
    // 输入文字变更
    const inputChange = ref(false);

    const transList = computed(() => {
      return upListTotal.value.filter((item: any) => item.status !== 'cancel');
    });

    const collectStatus = computed(() => {
      let result;
      const allSuccess =
        transList.value.every((item: { status: string }) => item.status === 'success') || transList.value.length === 0;
      const finishNum = transList.value.filter(
        (item: { status: string }) => item.status === 'error' || item.status === 'success',
      ).length;
      if (allSuccess) {
        result = CollectEnum.COLLECT;
      } else if (finishNum !== transList.value.length) {
        result = CollectEnum.COLLECTING;
      } else if (finishNum === transList.value.length) {
        result = CollectEnum.COLLECTERROR;
        loading.value = false;
      } else {
        result = CollectEnum.COLLECT;
      }
      return result;
    });
    const runningNum = computed(() => {
      return transList.value.filter((item: { status: string }) => {
        return (
          item.status === 'running' ||
          item.status === 'checking' ||
          item.status === 'waiting' ||
          item.status === 'paused' ||
          item.status === 'error'
        );
      }).length;
    });
    const collectNum = computed(() => {
      return collectingFileList.value.length || runningNum.value;
    });
    const showMoreFiles = computed(() => {
      let flag = true;
      if (collectTask.exampleFiles.length <= defaultExampleNum.value) {
        flag = false;
      }
      return flag;
    });

    const isDroping = ref(false);
    const dropTimer = ref<any>(null);

    // 文件收集步骤: 0初始页面、1添加文件页面、2上传成功页面
    const step = ref(0);

    // 列表任务数量
    const taskNum = computed(() => collectingFileList.value.length || runningNum.value);

    const methods = {
      async init() {
        if (collectToken.value) {
          try {
            context.emit('setInviteTitle', { type: 'mobileTitle', title: i18n_t('文件收集') });
            exchange.value = 'pending';
            await collectInfoMethods.getCollectInfo();
            vm.$emit('setOrgLogoInfo', orgLogoInfo.value);
            // userToken交换accessToken，无权限时为空
            const collectAccessToken = await methods.exchangeAccessToken();
            if (!collectAccessToken) {
              exchange.value = 'empty';
              return;
            }
            if (collectTask.status === 0 || isExpire.value || !collectTask.path || !props.isSubmit) {
              collectPanel.value = 'history';
            }
            const { data } = await smh.commonAPI.getCollectRule({
              collectToken: collectToken.value,
            });
            // 回显没做修改的文件收集命名规则
            Object.keys(data.rules).forEach(key => {
              vm.$set(ruleData, key, data.rules[key]);
              if (collectTask.namingRules.includes(key)) {
                ruleData[key] = data.rules[key];
              }
            });
            await collectInfoMethods.getHistoryList();
            await collectInfoMethods.getUserList();
            exchange.value = 'success';
          } catch (e: MsgError) {
            exchange.value = 'error';
            tips.error(e);
          }
        }
      },
      checkLimit(files: FileList | null) {
        if (!files || !files?.length) return true;
        const len = files.length;
        if (len > limit.value - collectingFileList.value.length) {
          tips.warning(i18n_t('添加文件数量超出最大限制{limitNum}个', { limitNum }));
          return true;
        }
        return false;
      },
      async exchangeAccessToken() {
        let collectAccessToken = '';
        try {
          const { isVistorLogined } = vm.$store.getters;
          const { isLogined } = vm.$store.getters;
          const { libraryId, spaceId } = collectTask;
          let res = null;
          if (isVistorLogined) {
            res = await smh.userAPI.getCollectAccessToken({
              collectToken: collectToken.value,
              userToken: Cookies.get('VISTOR_USER_TOKEN') as string,
            });
            collectAccessTokenManager.set(collectToken.value, {
              ...res.data,
              libraryId,
              spaceId,
            });
            collectAccessToken = res.data.collectAccessToken;
          } else if (isLogined) {
            res = await smh.userAPI.getCollectAccessTokenInner({
              collectToken: collectToken.value,
            });
            collectAccessTokenManager.set(collectToken.value, {
              ...res.data,
              libraryId,
              spaceId,
            });
            collectAccessToken = res.data.collectAccessToken;
          } else {
            collectAccessToken = '';
          }
        } catch (e: MsgError) {
          tips.error(e);
        }
        return collectAccessToken;
      },
      reportTabType() {
        switch (collectPanel.value) {
          case 'collect':
            break;
          case 'history':
            collectInfoMethods.getHistoryList();
            break;
          case 'collected':
            collectInfoMethods.getUserList();
            break;
          default:
            break;
        }
      },
      async chooseFile() {
        if (collectStatus.value === CollectEnum.COLLECTING) return;
        const form = vm.$refs.ruleForm as any;
        const validateResult = await form.validate();
        if (typeof validateResult === 'boolean' && validateResult) {
          step.value = 1;
          await collectFileMethods.chooseFile();
        } else {
          form.$children[0].$children[0].focus();
          tips.warning(i18n_t('请输入要求后再添加文件'));
        }
      },
      async addFiles() {
        // 用于选择文件的input对象
        const { fileInput, fileForm } = vm.$refs;
        const { files } = fileInput as HTMLInputElement;
        if (methods.checkLimit(files)) return;
        await collectFileMethods.addFiles(files);
        const form = fileForm as HTMLFormElement;
        form.reset();
      },
      async download(item: SMH.SpaceFileItemData, index: number) {
        try {
          const downloadData = [collectTask.exampleFiles[index]] as Array<SMH.SpaceFileItemData>;
          if (typeof downloadData[0].path === 'string') {
            const path = downloadData[0].path as unknown as string;
            downloadData[0].path = path.split('/');
          }
          const temp = {
            collectToken: collectToken.value,
            contentDisposition: 'attachment',
            filePath: downloadData[0].path.join('/') || '',
            spaceId: item.spaceId,
          };
          const {
            data: { cosUrl },
          } = await smh.commonAPI.getDownloadCosUrl(temp as any);
          if (IS_BROWSER) {
            downloadByLink(cosUrl, item.name);
          } else {
            const downloadPath = await getDownloadPath();
            if (!downloadPath) return;
            downloadUrlFileToLocal({
              url: cosUrl,
              downloadPath,
              downloadName: item.name,
              autoRename: true,
              openDirAfterDownload: true,
            });
          }
        } catch (e: MsgError) {
          tips.error(e);
        }
      },
      deleteFile(index: number) {
        collectFileMethods.deleteFile(index);
      },
      validateRule(validateItem: ValidateItem) {
        const { validateResult, firstError } = validateItem;
        let checkResult = true;
        Object.keys(validateResult).forEach(key => {
          if (validateResult[key][0].result === false) {
            tips.warning(firstError);
            loading.value = false;
            checkResult = false;
          }
        });
        checkResult && methods.submitForm();
        return;
      },
      async submitForm() {
        try {
          const { uploadPath, filesParam } = await collectFileMethods.prepareFileForm(ruleData);
          await fileMethods.upload(filesParam, uploadPath, collectTask.spaceId);
          // 记录用户输入规则的内容
          if (!_.isEqual(beforeRuleData, ruleData)) {
            await smh.commonAPI.saveCollectRule({ collectToken: collectToken.value, rules: ruleData });
          }
          // 上传成功之后获取历史记录和提交状态
          collectInfoMethods.getHistoryList();
          collectInfoMethods.getUserList();
          reporter.report('task_participate', {
            participate_type: vm.$store.getters.isVistorLogin ? 'outside' : 'inside',
          });
          reporter.report('file_submit', { file_num: collectingFileList.value.length });
        } catch (e: MsgError) {
          tips.error(e);
        } finally {
          loading.value = false;
        }
      },
      //  任务结束
      handlerCollectFinished(task: Task<FileInfo>): void {
        // 上传成功之后清空传输列表数据
        const fileForm = vm.$refs.fileForm as any;
        collectFileMethods.resetFormData();
        collectingFileList.value = [];
        if (fileForm) {
          fileForm.reset(); // 上传成功之后获取历史记录和提交状态
        }
        collectInfoMethods.getHistoryList();
        collectInfoMethods.getUserList();
        loading.value = false;
        if (collectNum.value === 0) {
          step.value = 2;
        }
      },
      async submit() {
        try {
          if (await methods.beforeSubmitCheck()) {
            loading.value = true;
            const form = vm.$refs.ruleForm as any;
            // 校验用户输入的规则是否改变
            const { data } = await smh.commonAPI.getCollectRule({
              collectToken: collectToken.value,
            });
            Object.assign(beforeRuleData, data.rules);
            if (!_.isEmpty(beforeRuleData)) {
              if (!_.isEqual(beforeRuleData, ruleData)) {
                inputChange.value = true;
              } else {
                inputChange.value = false;
                form.submit();
              }
            } else {
              form.submit();
            }
          }
        } catch (e: MsgError) {
          tips.error(e);
          loading.value = false;
        }
      },
      async beforeSubmitCheck() {
        let checkResult;
        try {
          // 提交前校验
          const { data: newCollectTask } = await smh.userAPI.getCollectTask({ collectToken: collectToken.value });
          const dialogInfo = { messageHeader: '', messageBody: '' };
          if (!newCollectTask.path) {
            dialogInfo.messageHeader = i18n_t('文件夹删除');
            dialogInfo.messageBody = i18n_t('文件夹被删除，请联系任务发起者');
            checkResult = false;
          } else if (newCollectTask.status === 0) {
            dialogInfo.messageHeader = i18n_t('任务未开启');
            dialogInfo.messageBody = i18n_t('任务未开启：请在任务有效时间内提交文件');
            checkResult = false;
          } else if (!newCollectTask.isPermanent && +dayjs(newCollectTask.expireTime) < Date.now()) {
            dialogInfo.messageHeader = i18n_t('任务已结束');
            dialogInfo.messageBody = i18n_t('当前收集任务已结束');
            checkResult = false;
          } else if (JSON.stringify(newCollectTask.namingRules) !== JSON.stringify(collectTask.namingRules)) {
            // 比较当前的命名规则和远端的命名规则
            dialogInfo.messageHeader = i18n_t('命名规则变更');
            dialogInfo.messageBody = i18n_t('任务发起人更改了命名规则，请刷新后重新填写并提交文件');
            checkResult = false;
          } else {
            checkResult = true;
          }
          if (!checkResult) {
            const dialog: DialogInstance = CustomDialog.confirm({
              theme: 'info',
              header: dialogInfo.messageHeader,
              body: dialogInfo.messageBody,
              cancelBtn: null,
              width: '400px',
              onConfirm() {
                if (dialog?.hide) {
                  dialog.hide();
                }
              },
            });
          }
        } catch (e: MsgError) {
          checkResult = false;
          tips.error(e);
        }
        return checkResult;
      },
      confirmNewRuleSubmit(val: string, context: { [key: string]: string }) {
        if (context && context.trigger === 'confirm') {
          const form = vm.$refs.ruleForm as any;
          form.submit();
        } else {
          loading.value = false;
        }
        inputChange.value = false;
      },
      formatSize(size: string | number) {
        const { speed, unit } = getSpeedAndUnit(Number(size));
        return `${speed}${unit}`;
      },
      allowDrop(event: DragEvent) {
        event.preventDefault();
        isDroping.value = true;
        window.clearTimeout(dropTimer.value);
        dropTimer.value = window.setTimeout(() => {
          isDroping.value = false;
        }, 100);
      },
      drop(event: DragEvent) {
        isDroping.value = false;
        event.preventDefault();
        const files = event.dataTransfer?.files as FileList;
        collectFileMethods.dropFiles(files);
      },
      moreFiles() {
        defaultExampleNum.value = collectTask.exampleFiles.length;
      },
      handlerUploadFileStart() {
        loading.value = true;
      },
      onAction(event: { command: string; actionType: string; task: Task<FileInfo> }) {
        const { command, task } = event;
        if (command === 'openTask') {
          if (!task.isDir) return;
          taskDetail.show = true;
          task.sortListByStatus();
          taskDetail.task = task;
        } else {
          handleTransmissionOperate(command, task, 'upload');
        }
      },
    };

    if (IS_BROWSER && !isInvalid.value && !isExpire.value) {
      // 拦截当前页面刷新和关闭
      const onBeforeunload = (event: BeforeUnloadEvent) => {
        const notSaveTips = i18n_t('确认离开当前页面？未保存的数据将会丢失。');
        const e = event || window.event;
        e.returnValue = notSaveTips;
        e.preventDefault();
        return notSaveTips;
      };
      window.addEventListener('beforeunload', onBeforeunload);
      onUnmounted(() => {
        window.removeEventListener('beforeunload', onBeforeunload);
      });
    }

    methods.init();

    watch(
      () => step.value,
      newVal => {
        if (newVal === 0) {
          context.emit('setInviteTitle', { type: 'mobileTitle', title: i18n_t('文件收集') });
        } else if (newVal === 1) {
          context.emit('setInviteTitle', {
            type: 'collectProgress',
            title: i18n_t('提交文件 ({slot1}/{slot2})', {
              slot1: collectingFileList.value.length || runningNum.value,
              slot2: limit.value,
            }),
          });
        }
      },
    );

    watch(
      () => taskNum.value,
      newVal => {
        if (step.value === 1) {
          context.emit('setInviteTitle', {
            type: 'collectProgress',
            title: i18n_t('提交文件 ({slot1}/{slot2})', {
              slot1: collectingFileList.value.length || runningNum.value,
              slot2: limit.value,
            }),
          });
        }
      },
    );

    onMounted(() => {
      taskManager.on(TaskEvents.taskFinish, methods.handlerCollectFinished);
    });

    onUnmounted(() => {
      taskManager.off('subtask-finish', methods.handlerCollectFinished);
      collectAccessTokenManager.clear();
      const { href } = window.location;
      // 网盘内部用户清理store中的collectToken(因为不清理的话会导致内部用户使用的accessToken不正确)
      if (href.includes('/fileCollect?tab=hasCollected')) {
        vm.$store.commit('SET_COLLECT_TOKEN', '');
      }
    });

    return {
      limit,
      limitNum,
      collectTask,
      orgLogoInfo,
      isExpire,
      isInvalid,
      exchange,
      loading,
      CollectEnum,
      acceptMediaTypes,
      collectPanel,
      collectingFileList,
      collectHistoryList,
      collectdUsers,
      ruleData,
      requiredRules,
      rulePrefix,
      collectStatus,
      defaultExampleNum,
      remainExampleFileNum,
      uploadList,
      upListTotal,
      taskDetail,
      transList,
      runningNum,
      inputChange,
      showMoreFiles,
      isDroping,
      step,
      ...collectInfoMethods,
      ...methods,
    };
  },
});
